/**
 * `/$org/apps/contract-intelligence`: Amoreg's contract review app, an area
 * of its own inside Apps — the rail selects Apps, the area's sidebar
 * (`ContractIntelligenceSidebarNav`) sits beside it, and each section is a
 * child route rendered here.
 *
 * @module routes/$org.apps.contract-intelligence
 */
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppsFrame } from "../components/apps/AppsFrame";

function ContractIntelligenceLayout() {
  return (
    <AppsFrame>
      <Outlet />
    </AppsFrame>
  );
}

export const Route = createFileRoute("/$org/apps/contract-intelligence")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: ContractIntelligenceLayout,
});
